import { z } from 'zod';

// Contact form schema
export const contactFormSchema = z.object({
  name: z.string().min(1, 'Name is required').max(100, 'Name must be less than 100 characters'),
  email: z.string().email('Please enter a valid email address'),
  company: z.string().max(100, 'Company name must be less than 100 characters').optional(),
  website: z.string().url('Please enter a valid URL').optional().or(z.literal('')),
  message: z
    .string()
    .min(20, 'Message must be at least 20 characters')
    .max(1500, 'Message must be less than 1500 characters'),
  hp: z.string().optional(), // honeypot field
});

export type ContactFormData = z.infer<typeof contactFormSchema>;

// API Response types
export interface ApiResponse<T = unknown> {
  success: boolean;
  message: string;
  data?: T;
}

export interface ContactResponse extends ApiResponse {
  data?: {
    id: string;
    timestamp: string;
  };
}

// Environment variables
export interface AppConfig {
  apiBase: string;
  recaptchaSiteKey: string;
}
